<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="mint-box type2">
        <div class="title">
          <span>{{ $t('mintpage.text1') }}</span>
        </div>
        <avatar ref="avatar"></avatar>
        <div class="des">
          <div class="tips" v-html="$t('mintpage.text7')"></div>
          {{ $t('mintpage.text8') }}
        </div>
        <div class="select-btn btns">
          <el-button type="default" class="round up" @click="handleBack()">{{
            $t('back')
          }}</el-button>
          <el-button
            class="el-button--special round up"
            @click="handleToMint"
            style="color: #ffffff"
            >{{ $t('mint') }}</el-button
          >
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box buy" v-if="popType === 'confirm'">
        <div class="pop-title">{{ $t('mintnft') }}</div>
        <div class="tips">{{ $t('mintpage.text9') }}</div>
        <div class="line-list">
          <div class="flexable">
            <div class="label">{{ $t('mintpage.text10') }}</div>
            <div class="price">
              <span>1,000</span>
            </div>
          </div>
          <div class="flexable">
            <div class="label"></div>
            <div class="price">{{ $t('total') }} <span>1,000</span></div>
          </div>
        </div>
        <el-button
          class="el-button--special block"
          v-if="!loading"
          style="margin-top: 0.34rem; color: #ffffff"
          @click="handleMint"
          >{{ $t('continue') }}</el-button
        >
        <el-button
          v-else
          :loading="true"
          class="el-button--special block"
          style="margin-top: 0.34rem; color: #ffffff"
          >{{ $t('continue') }}</el-button
        >
      </div>
      <div class="pop-box" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('mintnft') }}</div>
        <div class="result-box">
          <div class="h icons success">{{ $t('successed') }}</div>
          <div class="des special">
            <span>{{ $t('nftpage.text17') }}</span>
          </div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 1.7rem"
          @click="handleSuccess"
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'fail'">
        <div class="pop-title">{{ $t('purchasenft') }}</div>
        <div class="result-box">
          <div class="h icons warning">{{ $t('add.text42') }}</div>
          <div class="des">{{ $t('add.text43') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="handleRoute('/user/account')"
          >{{ $t('add.text44') }}</el-button
        >
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
// import { postMintFree } from '@/api/user'
import Avatar from '../../components/Avatar.vue'

export default {
  name: 'UserMintConfirm',
  components: {
    Avatar
  },
  data() {
    return {
      popupVisible: false,
      popType: null,
      rec_code: null,
      // isFree: false,
      loading: false
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
        if (!n) {
          this.loading = false
        }
      },
      deep: true
    }
  },
  mounted() {
    let params = JSON.parse(localStorage.getItem('mintinfo'))
    this.$refs.avatar.initData(params.imgData, params.selectIndexs)
  },
  methods: {
    handleMint() {
      if (this.$store.state.user_info.web5_score >= 1000) {
        this.loading = true
        this.$refs.avatar
          .mintUserImg((_) => {
            this.popType = 'success'
            this.newNFTUrl = _.path
            this.rec_code = _.rec_code
            this.loading = false
            this.$store.dispatch('setRefresh', {
              name: 'UserAccount',
              type: true
            })
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.popType = 'fail'
        this.popupVisible = true
      }
    },
    handleBack() {
      this.$router.push({
        name: 'UserMint',
        params: {
          selectIndexs: this.$refs.avatar.selectIndexs,
          imgData: this.$refs.avatar.imgs
        }
      })
    },
    handleToMint() {
      this.popType = 'confirm'
      this.popupVisible = true
      // postMintFree().then((res) => {
      //   this.isFree = res.data.is_free
      //   if (this.isFree) {
      //     this.popType = 'confirm'
      //     this.popupVisible = true
      //   } else {
      //     this.$toast({ message: this.$t('add.text35') })
      //   }
      // })
    },
    handleRoute(path) {
      this.$router.push({ path: path })
    },
    handleSuccess() {
      this.$router.push({
        path: '/user/mintsuccess',
        query: { rec_code: this.rec_code }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btns {
  .el-button {
    width: 1.58rem;
    height: 0.48rem;
    line-height: 0.48rem;
    font-size: 0.14rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/mintconfirm.vue